import { useQuery } from '@tanstack/react-query';
import { fetchActivePartners } from '../../api/partners';

export const useActivePartners = (options = {}) => {
  const query = useQuery({
    queryKey: ['partners', 'active'],
    queryFn: () => fetchActivePartners(),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    partners: query.data?.data?.partners ?? [],
  };
};

export default useActivePartners;

